import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TeamPerformance {
  id: string;
  team_name: string;
  department: string;
  period_start: string;
  period_end: string;
  team_size: number;
  active_members: number;
  total_revenue: number;
  total_bookings: number;
  avg_conversion_rate: number;
  avg_customer_satisfaction: number;
  total_tasks_completed: number;
  avg_task_completion_rate: number;
  avg_attendance_rate: number;
  team_score: number;
  team_rank?: number;
  team_members: string[];
  top_performer_id?: string;
  notes?: string;
  metadata?: Record<string, any>;
  created_at: string;
  top_performer?: {
    id: string;
    name: string;
  };
}

export const useTeamPerformance = (department?: string) => {
  return useQuery({
    queryKey: ["team-performance", department],
    queryFn: async () => {
      let query = supabase
        .from("team_performance")
        .select(`
          *,
          top_performer:employees!team_performance_top_performer_id_fkey(id, name)
        `)
        .order("team_score", { ascending: false });

      if (department) {
        query = query.eq("department", department);
      }

      const { data, error } = await query;

      if (error) throw error;
      return data as TeamPerformance[];
    },
  });
};